import { useTranslation } from 'react-i18next';

import { CreateCoursePermission } from '../auth/types';
import { ChildFabMenu, FabMenu, FabMenuItem } from '../components/FabMenu';
import CourseList from '../courses/CourseList';
import DemoCourse from '../courses/DemoCourse';
import JoinAnExistingCourseDrawer from '../courses/JoinAnExistingCourseDrawer';
import CreateCourseDrawer from '../create-course/CreateCourseDrawer';
import InformationAlert from '../create-course/InformationAlert';
import { i18nNS } from '../i18n';
import BookIcon from '../icons/BookIcon';
import BookOpenIcon from '../icons/BookOpenIcon';
import CloseIcon from '../icons/CloseIcon';
import FeatureUpdatesButton from './FeatureUpdatesButton';
import { CloseFabMenuItem, CourseListWrappper } from './styles';
import useHome from './vm';

const Home = () => {
  const { t } = useTranslation([i18nNS.HOME, i18nNS.CREATE_COURSE, i18nNS.COMMON, i18nNS.GLOSSARY]);

  const {
    session,
    isProvisionalAccount,
    isFetchingCourses,
    courseListWrapperRef,
    handleClickUnpublishedCourse,
    handleClickCreateCourse,
    handleClickJoinAnExistingCourse,
    isInformationAlertOpen,
    handleCloseInformationAlert,
    handleContinueInformationAlert,
    isCreateCourseDrawerOpen,
    handleCloseCreateCourseDrawer,
    selectedCourseId,
    isCreatingProCourse,
    isJoinAnExistingCourseDrawerOpen,
    handleCloseJoinAnExistingCourseDrawer,
  } = useHome();

  return (
    <>
      {!isProvisionalAccount && <FeatureUpdatesButton />}
      <CourseListWrappper gap={3} ref={courseListWrapperRef}>
        {isProvisionalAccount && !isFetchingCourses && <DemoCourse />}
        <CourseList
          isFetchingCourses={isFetchingCourses}
          canSeeNoCoursesCard={!isProvisionalAccount}
          onClickUnpublishedCourse={handleClickUnpublishedCourse}
        />
      </CourseListWrappper>
      {!isFetchingCourses && !isProvisionalAccount && (
        <>
          <FabMenu
            className="courseHomeFloatingButton"
            rootMenu="add_course_menu"
            aria-label={t('click_to_add_courses', { ns: i18nNS.HOME })}
          >
            <ChildFabMenu menuId="add_course_menu">
              {session.canCreateCourses !== CreateCoursePermission.NOT_ALLOWED && (
                <FabMenuItem
                  onClick={handleClickCreateCourse}
                  icon={<BookIcon />}
                  aria-label={t('click_to_create_a_new_course', { ns: i18nNS.CREATE_COURSE })}
                  autoFocus
                >
                  {t('create_a_new_course', { ns: i18nNS.CREATE_COURSE })}
                </FabMenuItem>
              )}
              <FabMenuItem
                onClick={handleClickJoinAnExistingCourse}
                icon={<BookOpenIcon />}
                aria-label={t('click_to_join_an_existing_course', { ns: i18nNS.CREATE_COURSE })}
              >
                {t('join_an_existing_course', { ns: i18nNS.HOME })}
              </FabMenuItem>
              <CloseFabMenuItem
                icon={<CloseIcon color="inherit" />}
                aria-label={t('click_to_cancel', { ns: i18nNS.COMMON })}
              >
                {t('cancel', { ns: i18nNS.GLOSSARY })}
              </CloseFabMenuItem>
            </ChildFabMenu>
          </FabMenu>
          <InformationAlert
            open={isInformationAlertOpen}
            onCancel={handleCloseInformationAlert}
            onContinue={handleContinueInformationAlert}
          />
          <CreateCourseDrawer
            open={isCreateCourseDrawerOpen}
            onClose={handleCloseCreateCourseDrawer}
            courseId={selectedCourseId}
            isCreatingProCourse={isCreatingProCourse}
          />
          <JoinAnExistingCourseDrawer
            open={isJoinAnExistingCourseDrawerOpen}
            onClose={handleCloseJoinAnExistingCourseDrawer}
          />
        </>
      )}
    </>
  );
};

export default Home;
